(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@sentry/browser"));
	else if(typeof define === 'function' && define.amd)
		define(["@sentry/browser"], factory);
	else if(typeof exports === 'object')
		exports["Applant"] = factory(require("@sentry/browser"));
	else
		root["Applant"] = root["Applant"] || {}, root["Applant"]["fragments"] = root["Applant"]["fragments"] || {}, root["Applant"]["fragments"]["koopa-fragment"] = factory(root["Sentry"]);
})((typeof self != 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__691__) {
return 